export default "__VITE_ASSET__D2Ss5Rwk__"